/**
 * 客户端操作上报类型枚举
 */
export enum ClientReportOpType {
  /** 分拣扫描 */
  SORTING_SCAN = 'sorting_scan',
  /** 揽件到件扫描 */
  PICKUP_ARRIVAL_SCAN = 'pickup_arrival_scan',
}

/**
 * 客户端操作上报类型（字符串类型，兼容枚举值）
 */
export type ClientReportOpTypeString = ClientReportOpType | string;

export interface ClientOperationReportRecord {
  reportKey: string;
  opType: ClientReportOpTypeString;
  barCode: string;
  deviceId?: string;
  clientIp?: string;
  createdAtMs: number;
  updatedAtMs: number;
  touchAtMs?: number;
  interceptAtMs?: number;
  interceptReason?: string;
  requestAtMs?: number;
  requestParamsJson?: string;
  requestHeadersJson?: string;
  responseAtMs?: number;
  responseResult?: string;
  lastAttemptAtMs?: number;
  attemptCount?: number;
}

export interface ClientOperationReportRecordPatch {
  barCode?: string;
  deviceId?: string;
  clientIp?: string;
  touchAtMs?: number;
  interceptAtMs?: number;
  interceptReason?: string;
  requestAtMs?: number;
  requestParamsJson?: string;
  requestHeadersJson?: string;
  responseAtMs?: number;
  responseResult?: string;
  lastAttemptAtMs?: number;
  attemptCount?: number;
}


